import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import seo from "@/seo/pages.json";

export const FaqSection = ({ items = seo.faq, eyebrow = "FAQ" }) => {
  const [open, setOpen] = useState(0);
  return (
    <section className="border-b border-black/5" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#52525B] mb-3">{eyebrow}</div>
          <h2 className="text-3xl md:text-4xl tracking-tight font-bold leading-tight">Questions,<br /><span className="text-[#ED5A24]">answered.</span></h2>
        </div>
        <div className="md:col-span-8 border-t border-black/10">
          {items.map((f, i) => (
            <div key={f.q} className="border-b border-black/10">
              <button type="button" onClick={() => setOpen(open === i ? -1 : i)} data-testid={`faq-q-${i}`} aria-expanded={open === i}
                className="w-full flex items-center justify-between gap-6 py-5 text-left font-bold hover:text-[#ED5A24] transition-colors duration-200">
                <h3 className="text-base">{f.q}</h3>
                {open === i ? <Minus className="w-4 h-4 shrink-0" /> : <Plus className="w-4 h-4 shrink-0" />}
              </button>
              {open === i && <p className="pb-5 text-[#52525B] leading-relaxed text-sm sm:text-base" data-testid={`faq-a-${i}`}>{f.a}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
